import authUtils from './authUtils';

import { FETCH_ME_SUCCESS, FETCH_ME_FAILURE, FETCH_ME_REQUEST, STATE_RESET, LOADING, CHANGE_ME_FAILURE, CHANGE_ME_SUCCESS } from './constants';

export function fetchMeSuccess(user) {
  return {
    type: FETCH_ME_SUCCESS,
    payload: {
      user,
    },
  };
}

export function fetchMeFailure() {
  authUtils.clearAuthToken();

  return {
    type: FETCH_ME_FAILURE,
  };
}

export function fetchMe() {
  return {
    type: FETCH_ME_REQUEST,
  };
}

export function resetState() {
  return {
    type: STATE_RESET,
  };
}

export function setLoading(value) {
  return {
    type: LOADING,
    value,
  };
}

export function changeMeSuccess(user) {
  return {
    type: CHANGE_ME_SUCCESS,
    payload: {
      user,
    },
  };
}

export function changeMeFailure(errors) {
  return {
    type: CHANGE_ME_FAILURE,
    errors,
  };
}